const name = 'CrossFade';
const properties = {
    defaultDuration: 0.6,
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        stagger: {
            type: 'number',
            default: 0,
        },
    },
};
/**
 * CrossFade between two elements, animation the source from 1 to 0 opacity while animating the destination from 0 to 1.
 */
function transition(kit, sourceElements, destElements, duration, delay, { stagger = 0, sourceEase = 'Sine.easeInOut', destEase = 'Sine.easeInOut', ...params } = {}) {
    const sequence = kit.sequence(params);
    sequence.add([
        kit.animate('BaseFade', sourceElements, duration, delay, {
            from: { opacity: 1 },
            to: { opacity: 0 },
            ease: sourceEase,
            stagger,
        }),
        kit.animate('BaseFade', destElements, duration, delay, {
            from: { opacity: 0 },
            to: { opacity: 1 },
            ease: destEase,
            stagger,
        }),
    ]);
    return sequence.get();
}
export { name, properties, transition };
//# sourceMappingURL=crossFade.js.map